import {useMutation} from 'react-query';
import {postSubBrandProduct} from '.';

const usePostSubBrandProduct = () => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IAddProductpayload) => postSubBrandProduct(payload),
  });

  return {mutate, isLoading};
};

export default usePostSubBrandProduct;
